import Highlight from "./highlight";
import {ActionTypeEnum} from "../../base/training-literals";
import {SelectionObjectTypeEnum} from "../action-literals";

class Transparency extends Highlight {
    constructor(props = {}) {
        super(props);
        this.actionType = props.actionType || ActionTypeEnum.TRANSPARENCY;
    }

    startSelection() {
        if (!this.selectionEnable) {
            super.startSelection();
            return;
        }

        changeSelectionAction(SelectionActionEnum.Transparency);
        if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            SelectionData.changeResetOnOutsideClickState(true);
            onChangeApplyToSelection(false);
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            SelectionData.changeResetOnOutsideClickState(true);
            onChangeApplyToSelection(true);
        }
    }

    stopSelection() {
        VRMessageController.addMessage({
            text: "Selection Stopped",
            priority: VrMessagePriorityEnum.LOWPRIORITYINFO
        });
        if (!this.selectionEnable) {
            updateYellowHighlightFlag(false);
        }
        this.set2dElementsVisibility(true);
        onChangeApplyToSelection(true);
        changeSelectionAction(SelectionActionEnum.NONE);
    }

    selectItems(items, isTransparent) {
        if (!this.selectionEnable) {
            super.selectItems(items, isTransparent);
            return;
        }

        if (this.selectionObjectType === SelectionObjectTypeEnum.Volumes) {
            for (const item of items) {
                performTransparencyOperationOnVolume(item.id, isTransparent);
            }
        } else if (this.selectionObjectType === SelectionObjectTypeEnum.Models) {
            for (const item of items) {
                performTransparencyOperationOnModel(item.id, isTransparent);
            }
        }
    }

    sendDataOnSelection(data) {
        let msg = text_selectionObjects;
        this.sendDataToWeb(msg.command, data);
    }
}

export default Transparency;